import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { SubSink } from 'subsink';
import { MxBaseComponent } from '../../base/mx.base-component';

import { MxEventBusService, MxEvents } from '../../services';

@Component({ standalone: false,
  selector: 'mx-overlay',
  templateUrl: './mx.overlay.component.html',
  styleUrls: ['./mx.overlay.component.scss']
})
export class MxOverlayComponent
  extends MxBaseComponent
  implements OnInit, OnDestroy
{
  subs = new SubSink();

  enabled = false;
  queue: any[] = [];
  timerId: number = null;
  timerHideId: number = null;

  @Input() delay = 0;
  @Input() stopDelay = 500;

  constructor(
    private eventBus: MxEventBusService,
    private cd: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    // Handle request
    this.subs.sink = this.eventBus.on(MxEvents.HttpRequest, () => {
      this.queue.push({});
      if (this.queue.length === 1) {
        // Only show if we have an item in the queue after the delay time
        setTimeout(() => {
          if (this.queue.length) {
            this.enabled = true;
          }
        }, this.delay);
      }
    });

    // Handle response
    this.subs.sink = this.eventBus.on(MxEvents.HttpResponse, () => {
      this.queue.pop();
      if (this.queue.length === 0) {
        // Since we don't know if another XHR request will be made, pause before
        // hiding the overlay. If another XHR request comes in then the overlay
        // will stay visible which prevents a flicker
        setTimeout(() => {
          // Make sure queue is still 0 since a new XHR request may have come in
          // while timer was running
          if (this.queue.length === 0) {
            this.enabled = false;
          }
        }, this.stopDelay);
      }
    });

    // Handle response
    this.subs.sink = this.eventBus.on(MxEvents.ColorSchemaChange, () => {
      this.enabled = true;
      setTimeout(() => {
        this.enabled = false;
      }, this.stopDelay);
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
